import { APICore } from './apiCore';

const api = new APICore();

type UpdateUserData = {
    uuid: string,
    uuid_edit: string
    permission: number
    email: string
    user_name: string
    type_user_id: number
    password: string
    uuid_clinic: string
    reference_id: string
    name: string
    last_name: string
    birth_date: string
    phone: string
    emergency_phone: string
    birth_address: string
    address: string
    height: number
    Weight: number
    gender_id: number
    photo: string
    about_user: string
    unit_temperature_id: number
    unit_weight_id: number
    unit_height_id: number
};

function getUserData(params: { uuid: string }) {
    const baseUrl = '/getUserInfo/';
    const payload = {
        uuid : params.uuid,
    }
    // console.log( payload);
    return api.create(`${baseUrl}`, payload);
}
function getClinicDoctors(params: { uuid: string }) {
    const baseUrl = '/getClinicDoctors/';
    const payload = {
        uuid : params.uuid,
    }
    // console.log( payload);
    return api.create(`${baseUrl}`, payload);
}

function getUserClinic(params: { uuid: string }) {
    const baseUrl = '/GetUserClinic/';
    const payload = {
        uuid : params.uuid,
    }
    // console.log( payload);
    return api.create(`${baseUrl}`, payload);
}

function updateUser(user: UpdateUserData) {
    const baseUrl = '/updateUser/';
    const payload = user

    return api.create(`${baseUrl}`, payload);
}


function getUsers(params: { TypeUser : number }) {
    const baseUrl = '/getUsers/';
    const payload = {
        type_user_id: params.TypeUser
    }
    
    return api.create(`${baseUrl}`, payload);
}

function getUserInfo(params: { uuid_user: string,user_name: string, TypeUser : number }) {
    const baseUrl = '/GetUserInfo/';
    const payload = {
        email: "",
        user_name: params.user_name,
        password: "",
        reference_id: "",
        name: "",
        last_name: "",
        birth_date: "",
        phone: "",
        gender_id: 0,
        address: "",
        type_user_id: params.TypeUser
    }
    
    return api.create(`${baseUrl}`, payload);
}
function getUserStatisticsClinic(params: { uuid_user: string }) {
    const baseUrl = '/getUserStatisticsClinic/';
    const payload = {
        uuid: params.uuid_user,
       
    }
    
    return api.create(`${baseUrl}`, payload);
}

function getPatientsDoctors(params: { uuid: string, uuidClinic: string }) {
    const baseUrl = '/getPatientsDoctors/';
    const payload = {
        uuid : params.uuid,
        uuidClinic : params.uuidClinic//,
        //year : params.year,
    }

    return api.create(`${baseUrl}`, payload);
}
function setDoctorToPatient(params: { uuid: string, uuidDoctor: string , uuidClinic: string }) {
    const baseUrl = '/setDoctorToPatient/';
    const payload = {
        uuid : params.uuid,
        uuidDoctor : params.uuidDoctor,
        uuidClinic : params.uuidClinic//,
        //year : params.year,
    }

    return api.create(`${baseUrl}`, payload);
}

function getUserPermission(params: { uuid : string }) {
    const baseUrl = '/getDoctorPermissions/';
    const payload = {
        uuid: params.uuid
    }
    
    return api.create(`${baseUrl}`, payload);
}

function setUserPermission(params: { uuid : string, permit : number }) {
    const baseUrl = '/setDoctorPermission/';
    const payload = {
        uuid: params.uuid,
        permission: params.permit
    }
    
    return api.create(`${baseUrl}`, payload);
}


export {getUserData, updateUser,getUserClinic,
     getClinicDoctors,getUsers,getUserInfo, getPatientsDoctors
     ,setDoctorToPatient, getUserPermission, setUserPermission
    ,getUserStatisticsClinic};
